import { render, staticRenderFns } from "./DadosCadastrais.vue?vue&type=template&id=0858ec04&scoped=true&"
import script from "./DadosCadastrais.vue?vue&type=script&lang=js&"
export * from "./DadosCadastrais.vue?vue&type=script&lang=js&"
import style0 from "./DadosCadastrais.vue?vue&type=style&index=0&id=0858ec04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0858ec04",
  null
  
)

export default component.exports